const askquestion = {
    // Header Section
    "discover_your": "अपना",
    "ask_question": "प्रश्न पूछें",
    "personalized_answers": "व्यक्तिगत ज्योतिषीय उत्तर",
    "ask_question_description": "अपने जीवन के बारे में कोई भी विशिष्ट प्रश्न पूछें और विस्तृत ज्योतिषीय उत्तर प्राप्त करें। हमारे विशेषज्ञ ज्योतिषी व्यावहारिक मार्गदर्शन और उपचारात्मक समाधानों के साथ आपकी जन्म कुंडली के आधार पर व्यक्तिगत अंतर्दृष्टि प्रदान करते हैं।",

    // Service Information
    "enter_details_for_question": "अपना विवरण और प्रश्न दर्ज करें",
    "personalized_question_answer": "व्यक्तिगत प्रश्न उत्तर",
    "service_price": "सेवा मूल्य",
    "personalized_question_answer_note": "मार्गदर्शन के साथ आपके विशिष्ट प्रश्न का विशेषज्ञ ज्योतिषीय उत्तर",

    // Form Fields
    "full_name": "पूरा नाम",
    "enter_full_name": "अपना पूरा नाम दर्ज करें",
    "name_question_context": "आपका नाम आपके प्रश्न के लिए व्यक्तिगत संदर्भ प्रदान करने में मदद करता है",
    "email_address": "ईमेल पता",
    "enter_email_address": "अपना ईमेल पता दर्ज करें",
    "phone_number": "फोन नंबर",
    "enter_phone_number": "अपना फोन नंबर दर्ज करें",
    "gender": "लिंग",
    "male": "पुरुष",
    "female": "स्त्री",
    "other": "अन्य",
    "date_of_birth": "जन्म तिथि",
    "birth_date_question_context": "ज्योतिषीय संदर्भ और सटीक उत्तर के लिए आवश्यक",
    "your_question": "आपका प्रश्न",
    "enter_your_question": "यहाँ अपना विशिष्ट प्रश्न दर्ज करें...",
    "question_guidance": "स्पष्ट और विशिष्ट रहें। करियर, प्रेम, वित्त, स्वास्थ्य, परिवार या किसी भी जीवन विषय के बारे में पूछें",
    "question_category": "प्रश्न श्रेणी",
    "select_category": "प्रश्न श्रेणी चुनें",
    "career_question": "करियर और व्यापार",
    "love_relationship_question": "प्रेम और रिश्ते",
    "finance_question": "वित्त और धन",
    "health_question": "स्वास्थ्य और कल्याण",
    "family_question": "पारिवारिक और व्यक्तिगत",
    "spiritual_question": "आध्यात्मिक और विकास",
    "general_question": "सामान्य जीवन",
    "category_helps_accuracy": "श्रेणी चयन अधिक सटीक और प्रासंगिक उत्तर प्रदान करने में मदद करता है",
    "preferred_language": "पसंदीदा भाषा",
    "english": "अंग्रेजी",
    "hindi": "हिंदी",
    "telugu": "तेलुगू",
    "kannada": "कन्नड़",
    "language_note": "आपका उत्तर चुनी गई भाषा में प्रदान किया जाएगा",

    // Core Question Features
    "detailed_answer_explanation": "विस्तृत उत्तर और स्पष्टीकरण",
    "astrological_context": "ज्योतिषीय संदर्भ",
    "timing_guidance": "समय मार्गदर्शन",
    "remedial_suggestions": "उपचारात्मक सुझाव",
    "follow_up_guidance": "अनुवर्ती मार्गदर्शन",
    "pdf_answer_report": "पीडीएफ उत्तर रिपोर्ट",

    "what_you_get": "आपके उत्तर में क्या शामिल है",
    "comprehensive_answer": "व्यापक उत्तर",
    "astrological_insights": "ज्योतिषीय अंतर्दृष्टि",
    "practical_guidance": "व्यावहारिक मार्गदर्शन",
    "remedial_solutions": "उपचारात्मक समाधान",

    // Actions & Buttons
    "pay_and_get_answer": "मेरा उत्तर प्राप्त करें",
    "processing_payment": "भुगतान प्रसंस्करण",
    "processing_request": "प्रश्न प्रसंस्करण",

    // Payment & Success Messages
    "thank_you": "धन्यवाद",
    "payment_successful": "भुगतान सफल!",
    "question_answer_processing": "आपके प्रश्न का विश्लेषण हमारे विशेषज्ञ ज्योतिषियों द्वारा किया जा रहा है। आपको ज्योतिषीय अंतर्दृष्टि और व्यावहारिक मार्गदर्शन के साथ एक विस्तृत व्यक्तिगत उत्तर प्राप्त होगा।",
    "order_id": "ऑर्डर आईडी",
    "payment_id": "भुगतान आईडी",
    "amount_paid": "भुगतान की गई राशि",

    // Delivery Information
    "delivery_information": "डिलीवरी जानकारी",
    "delivery_time": "उत्तर डिलीवरी",
    "within_6_hours_delivery_note": "आपका विस्तृत उत्तर 6 घंटों के भीतर तैयार हो जाएगा",
    "whatsapp_notification": "व्हाट्सऐप अपडेट",
    "whatsapp_delivery_note": "व्हाट्सऐप पर तुरंत सूचनाएं प्राप्त करें",
    "email_delivery": "ईमेल डिलीवरी",
    "email_delivery_note": "पूरा उत्तर इस पर भेजा गया",

    // What You'll Receive
    "what_youll_receive": "आपका उत्तर पैकेज",
    "detailed_answer_report_pdf": "विस्तृत उत्तर रिपोर्ट (पीडीएफ)",
    "astrological_explanation": "ज्योतिषीय व्याख्या",
    "timing_recommendations": "समय सिफारिशें",
    "remedial_measures": "उपचारात्मक उपाय",
    "action_plan_guidance": "कार्य योजना मार्गदर्शन",

    // Visual Content
    "sample_question_answer": "नमूना प्रश्न उत्तर",
    "expert_answer": "विशेषज्ञ उत्तर",
    "sample_answer_preview": "व्यावहारिक मार्गदर्शन और समय के साथ विस्तृत ज्योतिषीय अंतर्दृष्टि",
    "sample_question_preview": "हमारे विशेषज्ञ आपके विशिष्ट प्रश्नों का उत्तर कैसे देते हैं इसका पूर्वावलोकन",
    "question_categories": "प्रश्न श्रेणियां",

    // Question Category Types
    "career": "करियर",
    "love": "प्रेम",
    "finance": "वित्त",
    "health": "स्वास्थ्य",
    "family": "परिवार",
    "spiritual": "आध्यात्मिक",

    // Status & Processing
    "your_question_status": "आपके प्रश्न की स्थिति",
    "processing_your_question": "आपके प्रश्न का विश्लेषण",
    "question_processing_message": "हमारे विशेषज्ञ ज्योतिषी सबसे सटीक और सहायक उत्तर प्रदान करने के लिए आपकी जन्म कुंडली का अध्ययन कर रहे हैं और आपके प्रश्न का विश्लेषण कर रहे हैं।",
    "request_id": "प्रश्न आईडी",
    "status": "स्थिति",
    "processing": "प्रगति में",
    "pending": "कतार में",
    "email_notification_sent": "पुष्टिकरण ईमेल भेजा गया",
    "whatsapp_update_coming": "व्हाट्सऐप अपडेट सक्षम",
    "delivery_within_6_hours": "उत्तर 6 घंटों के भीतर तैयार",

    // Support & Contact
    "contact_support": "प्रश्न सहायता से संपर्क करें",
    "need_help": "मार्गदर्शन चाहिए?",
    "contact_us_at": "हमसे संपर्क करें",

    // Error Messages
    "please_fill_all_required_fields": "कृपया अपने प्रश्न सहित सभी आवश्यक फील्ड पूरे करें",
    "payment_failed": "भुगतान असफल। कृपया पुनः प्रयास करें।",
    "processing_failed": "प्रश्न प्रसंस्करण असफल। हमारी सहायता टीम से संपर्क करें।",

    // Question Types & Examples
    "career_questions_examples": "करियर प्रश्न उदाहरण",
    "when_promotion": "मुझे पदोन्नति कब मिलेगी?",
    "job_change_timing": "क्या मुझे अभी नौकरी बदलनी चाहिए?",
    "business_success": "क्या मेरा व्यापार सफल होगा?",
    "career_path": "मेरे लिए कौन सा करियर पथ सबसे अच्छा है?",

    "love_questions_examples": "प्रेम प्रश्न उदाहरण",
    "marriage_timing": "मेरा विवाह कब होगा?",
    "relationship_future": "मेरे रिश्ते का भविष्य क्या है?",
    "soulmate_meeting": "मैं अपने आत्मा साथी से कब मिलूंगा?",
    "love_compatibility_question": "क्या हम विवाह के लिए अनुकूल हैं?",

    "finance_questions_examples": "वित्त प्रश्न उदाहरण",
    "money_problems": "मेरी वित्तीय समस्याएं कब समाप्त होंगी?",
    "investment_timing": "क्या यह निवेश का अच्छा समय है?",
    "property_purchase": "क्या मुझे अभी संपत्ति खरीदनी चाहिए?",
    "debt_relief": "मैं कब ऋण मुक्त हो जाऊंगा?",

    "health_questions_examples": "स्वास्थ्य प्रश्न उदाहरण",
    "health_recovery": "मेरा स्वास्थ्य कब सुधरेगा?",
    "surgery_timing": "क्या यह सर्जरी का अच्छा समय है?",
    "chronic_illness": "क्या मेरी पुरानी बीमारी ठीक होगी?",
    "fitness_goals": "मैं अपने स्वास्थ्य लक्ष्यों को कैसे प्राप्त कर सकता हूं?",

    // Answer Components
    "question_analysis": "प्रश्न विश्लेषण",
    "birth_chart_insights": "जन्म कुंडली अंतर्दृष्टि",
    "planetary_influences": "ग्रहीय प्रभाव",
    "current_transits": "वर्तमान गोचर प्रभाव",
    "dasha_analysis": "दशा अवधि विश्लेषण",
    "yogas_doshas": "संबंधित योग और दोष",

    // Timing Analysis
    "favorable_periods": "अनुकूल अवधि",
    "challenging_periods": "चुनौतीपूर्ण अवधि",
    "optimal_timing": "इष्टतम समय",
    "avoid_periods": "बचने योग्य अवधि",
    "gradual_improvement": "क्रमिक सुधार समयरेखा",
    "sudden_changes": "अचानक परिवर्तन संभावनाएं",

    // Remedial Solutions
    "gemstone_remedies": "रत्न उपचार",
    "mantra_recommendations": "मंत्र सिफारिशें",
    "charity_suggestions": "दान सुझाव",
    "ritual_guidance": "अनुष्ठान और पूजा मार्गदर्शन",
    "lifestyle_changes": "जीवनशैली संशोधन",
    "behavioral_adjustments": "व्यवहारिक समायोजन",

    // Practical Guidance
    "action_steps": "अनुशंसित कार्य चरण",
    "do_and_dont": "करें और न करें",
    "precautions": "बरती जाने वाली सावधानियां",
    "opportunities": "देखने योग्य अवसर",
    "preparation_tips": "तैयारी के सुझाव",
    "patience_guidance": "कब धैर्य रखें",

    // Follow-up Information
    "progress_tracking": "प्रगति ट्रैकिंग",
    "reassessment_timing": "पुनर्मूल्यांकन का समय",
    "additional_questions": "विचार करने योग्य संबंधित प्रश्न",
    "ongoing_guidance": "निरंतर मार्गदर्शन",
    "support_resources": "सहायता संसाधन",
    "expert_consultation": "विशेषज्ञ परामर्श उपलब्ध",

    // Question Quality Guidelines
    "specific_questions": "विशिष्ट प्रश्न पूछें",
    "avoid_yes_no": "सरल हां/नहीं प्रश्नों से बचें",
    "include_context": "प्रासंगिक संदर्भ शामिल करें",
    "one_main_question": "एक मुख्य प्रश्न पर ध्यान दें",
    "clear_timeline": "वांछित समयरेखा का उल्लेख करें",
    "personal_concerns": "व्यक्तिगत चिंताओं को व्यक्त करें",

    // Answer Accuracy Factors
    "birth_time_accuracy": "जन्म समय की सटीकता महत्वपूर्ण",
    "current_circumstances": "वर्तमान जीवन परिस्थितियां",
    "personal_efforts": "व्यक्तिगत प्रयास मायने रखते हैं",
    "free_will_factor": "स्वतंत्र इच्छा विचारणा",
    "karmic_influences": "कार्मिक प्रभाव",
    "divine_grace": "दिव्य कृपा कारक",

    // Special Question Categories
    "urgent_questions": "जरूरी जीवन प्रश्न",
    "long_term_planning": "दीर्घकालिक जीवन योजना",
    "decision_making": "महत्वपूर्ण निर्णय लेना",
    "crisis_management": "संकट और चुनौती प्रबंधन",
    "opportunity_evaluation": "अवसर मूल्यांकन",
    "relationship_counseling": "रिश्ते का मार्गदर्शन",

    // Confidentiality
    "privacy_assurance": "पूर्ण गोपनीयता आश्वासन",
    "confidential_handling": "गोपनीय प्रश्न हैंडलिंग",
    "secure_communication": "सुरक्षित संचार",
    "expert_discretion": "विशेषज्ञ विवेक बनाए रखा गया",
    "no_judgment": "बिना निर्णय दृष्टिकोण",
    "supportive_guidance": "सहयोगी और दयालु मार्गदर्शन"
};

export default askquestion;
